import { render, staticRenderFns } from "./MatchDetail.vue?vue&type=template&id=55885b83&"
import script from "./MatchDetail.vue?vue&type=script&lang=js&"
export * from "./MatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./MatchDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports